import { GeckoComponentModelType } from 'types'

/**
 * returns if a given `componentType` wrap horizontally
 * @param componentType
 */
export function doesComponentWrapHorizontally(
  componentType: GeckoComponentModelType
): boolean {
  switch (componentType) {
    // yeses
    case GeckoComponentModelType.VerticalTankShell:
    case GeckoComponentModelType.LaunchTube:
    case GeckoComponentModelType.PipeSection: // technically y is the length, so it wraps horizontally
    case GeckoComponentModelType.PipeEccentricReducer:
    case GeckoComponentModelType.Dome:
    case GeckoComponentModelType.DomeWall:
    case GeckoComponentModelType.VerticalTankFoundation:
    case GeckoComponentModelType.PressureVesselShell:
    case GeckoComponentModelType.HemisphericalHead:
    case GeckoComponentModelType.HoodStraight:
    case GeckoComponentModelType.HoodBend:
      return true

    // nos
    case GeckoComponentModelType.HorizontalTankShell:
    case GeckoComponentModelType.LegacyCone:
    case GeckoComponentModelType.Cone:
    case GeckoComponentModelType.ShipDeck:
    case GeckoComponentModelType.BasicShipHull:
    case GeckoComponentModelType.LegacyBoilerWalls:
    case GeckoComponentModelType.TankFlatRoof:
    case GeckoComponentModelType.TankFloor:
    case GeckoComponentModelType.FlatCircularFloor:
    case GeckoComponentModelType.PipeElbow:
    case GeckoComponentModelType.MachinedForgingSimple:
    case GeckoComponentModelType.TorisphericalHead:
    case GeckoComponentModelType.EllipsoidalHead:
    case GeckoComponentModelType.SphereFlatCap:
    case GeckoComponentModelType.PipeTJoint:
      return false
  }
}

/**
 * returns if a given `componentType` wrap vertically
 * @param componentType
 */
export function doesComponentWrapVertically(
  componentType: GeckoComponentModelType
): boolean {
  switch (componentType) {
    // yeses
    case GeckoComponentModelType.HorizontalTankShell:
    case GeckoComponentModelType.PipeElbow:
    case GeckoComponentModelType.PipeTJoint:
      return true

    // nos
    case GeckoComponentModelType.TankFloor:
    case GeckoComponentModelType.TankFlatRoof:
    case GeckoComponentModelType.LegacyBoilerWalls:
    case GeckoComponentModelType.ShipDeck:
    case GeckoComponentModelType.BasicShipHull:
    case GeckoComponentModelType.LegacyCone:
    case GeckoComponentModelType.Cone:
    case GeckoComponentModelType.PipeSection: // technically y is the length, so it wraps horizontally
    case GeckoComponentModelType.PipeEccentricReducer:
    case GeckoComponentModelType.LaunchTube:
    case GeckoComponentModelType.VerticalTankShell:
    case GeckoComponentModelType.Dome:
    case GeckoComponentModelType.DomeWall:
    case GeckoComponentModelType.FlatCircularFloor:
    case GeckoComponentModelType.VerticalTankFoundation:
    case GeckoComponentModelType.MachinedForgingSimple:
    case GeckoComponentModelType.PressureVesselShell:
    case GeckoComponentModelType.HemisphericalHead:
    case GeckoComponentModelType.TorisphericalHead:
    case GeckoComponentModelType.EllipsoidalHead:
    case GeckoComponentModelType.SphereFlatCap:
    case GeckoComponentModelType.HoodStraight:
    case GeckoComponentModelType.HoodBend:
      return false
  }
}
